
import { defineComponent } from 'vue'
import { iLayer } from '@/modules/workspace/gisDocumentDesigner/GisDocumentDesigner'
import { filterDefault } from '@/helpers/commons/filterHelper'
import descriptor from './GisDocumentDesignerDataset&LayerDescriptor.json'
import styleDescriptor from '@/modules/workspace/gisDocumentDesigner/GisDocumentDesignerDescriptor.json'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'

const deepcopy = require('deepcopy')

export default defineComponent({
    components: {
        DataTable,
        Column,
        Dialog
    },
    emits: ['layerChanged'],
    props: { documentDataProp: { type: Object as any, required: false }, isDatasetChosen: Boolean },
    computed: {},
    data() {
        return {
            descriptor,
            styleDescriptor,
            columns: descriptor.layerColumns,
            globalFilterFields: descriptor.layerFilterFields,
            mainFilters: { global: [filterDefault] } as Object,
            singleFilters: { global: [filterDefault] } as Object,
            multipleFilters: { global: [filterDefault] } as Object,
            layerDialogVisible: false,
            selectedLayer: {} as iLayer,
            selectedLayersList: [] as iLayer[],
            documentData: {} as any
        }
    },
    created() {
        this.documentData = this.documentDataProp
    },

    methods: {
        showLayerDialogConfirm() {
            if (this.isDatasetChosen && this.documentData.dsJoins.length > 0) {
                this.$confirm.require({
                    header: this.$t('common.toast.warning'),
                    message: this.$t('workspace.gis.dnl.changeLayerMessage'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.showLayerDialog()
                    }
                })
            } else {
                this.showLayerDialog()
            }
        },
        showLayerDialog() {
            this.isDatasetChosen ? (this.selectedLayer = deepcopy(this.documentData.selectedLayer[0])) : (this.selectedLayer = deepcopy(this.documentData.selectedLayer))
            this.layerDialogVisible = true
        },
        closeDialog() {
            this.selectedLayer = {} as iLayer
            this.selectedLayersList = [] as iLayer[]
            this.layerDialogVisible = false
        },
        saveLayerSelection() {
            this.isDatasetChosen ? (this.documentData.selectedLayer = deepcopy([this.selectedLayer])) : (this.documentData.selectedLayer = deepcopy(this.selectedLayersList))
            this.documentData.dsJoins = []
            this.$emit('layerChanged', this.isDatasetChosen ? [this.selectedLayer] : this.selectedLayersList)
            this.layerDialogVisible = false
        },
        deleteSelectedLayer(eventData) {
            this.documentData.selectedLayer.splice(eventData.index, 1)
        }
    }
})
